import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--dark",
  "use": "icon-play--dark-usage",
  "viewBox": "0 0 65 65",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 65 65\" id=\"icon-play--dark\"><circle cx=\"32.429\" cy=\"32.167\" r=\"32.147\" fill=\"#111921\" /><path d=\"m41.826 31.748-14.948 8.63v-17.26l14.948 8.63Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol